export default __webpack_public_path__ + "static/media/pictogramBeaconEFTPOS40.977cbb3b.svg";